<template>
  <div class="select-picker">
    <van-popup
      closeable
      close-icon-position="top-left"
      v-model="visible"
      position="bottom"
      :style="{ height: height }"
    >
      <div class="select-box">
        <van-button type="info" size="mini" @click="onClear" class="clear-btn"
          >清除</van-button
        >
        <van-search
          :placeholder="placeholder"
          style="border-bottom:1px solid #f1f1f1;"
          class="search-box"
          v-model="keyword"
          @search="onSearch"
        />
        <data-list
          :api="method"
          :params="listParams"
          style="height: calc(100vh - 66px); overflow: hidden;overflow-y: auto;"
        >
          <template v-slot:item="item">
            <van-cell
              center
              :title="item[titleField]"
              :value="item[valueField]"
              :label="item[labelField]"
              @click="handleSelect(item)"
            />
          </template>
        </data-list>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getMemberList } from "@/api/member.js";
import DataList from "@/components/DataList";

import { Popup, Picker, Cell, CellGroup, Icon, Search, Button } from "vant";
export default {
  name: "SelectMultiplePicker",
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Button.name]: Button,
    DataList,
  },
  props: {
    height: {
      type: String,
      default: "100%",
    },
    method: {
      type: Function,
      default: getMemberList,
    },
    titleField: {
      type: String,
      default: "Name",
    },
    valueField: {
      type: String,
      default: "Balance",
    },
    labelField: {
      type: String,
      default: "CardNo",
    },
    placeholder: {
      type: String,
      default: "请输入会员姓名/卡号",
    },
    searchField: {
      type: String,
      default: "Keyword",
    },
    change: { type: Function },
    clear: { type: Function },
  },
  data() {
    return {
      getMemberList,
      listParams: {},
      visible: false,
      keyword: "",
      checkedValue: [],
      checkedData: [],
    };
  },
  created: function() {},
  mounted() {
    this.visible = true;
  },

  methods: {
    onSearch() {
      this.listParams = {
        [this.searchField]: this.keyword,
      };
    },
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    },
    handleSelect(item) {
      this.$emit("change", item);
      this.visible = false;
      this.$emit("destroy");
    },
    onClear() {
      this.$emit("clear");
      this.visible = false;
      this.$emit("destroy");
    },
  },
};
</script>

<style lang="less" scoped>
.select-box {
  position: relative;
  height: 100vh;
  padding-top: 90px;
  .search-box {
    position: absolute;
    top: 40px;
    width: 100%;
    // position: ab;
  }
  .clear-btn {
    position: absolute;
    right: 15px;
    top: 15px;
  }
}
</style>
